import React from "react";

type ReferenceImagesRowProps = {
  referenceImage?: string | string[] | null;
  label?: string;
  baseUrl?: string;
};

const ReferenceImagesRow: React.FC<ReferenceImagesRowProps> = ({
  referenceImage,
  label = "Reference Images:",
  baseUrl,
}) => {
  if (!referenceImage) {
    return null;
  }

  let images: string[] = [];
  try {
    if (typeof referenceImage === "string") {
      images = JSON.parse(referenceImage);
    } else if (Array.isArray(referenceImage)) {
      images = referenceImage;
    }
  } catch {
    images = [];
  }

  if (!images.length) {
    return null;
  }

  const resolvedBaseUrl = baseUrl || process.env.REACT_APP_HAPS_MAIN_BASE_URL || "";

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs mb-2">
      <div className="col-span-1 font-semibold text-gray-600">{label}</div>
      <div className="col-span-1 md:col-span-3 flex flex-wrap gap-2 items-center">
        {images.map((image, imgIdx) => (
          <a
            key={`${image}-${imgIdx}`}
            href={`${resolvedBaseUrl}${image}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline text-xs mr-2"
          >
            Media {imgIdx + 1}
          </a>
        ))}
      </div>
    </div>
  );
};

export default ReferenceImagesRow;
